var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"fullpage"}},[_c('pageHeader'),_c('router-view'),_c('Footer'),_c('el-backtop',{ref:"backTop",attrs:{"target":"html","bottom":100}},[_c('i',{staticClass:"el-icon-caret-top"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }